import { css } from "styled-components";
import { themeGet } from "styled-system";

const lineHeight = css`
  line-height: ${themeGet("lineHeight")};
`;

export default lineHeight;
